import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import megaphone from "../../assets/img/megafono.png";

const Aliado = () => {
  return (
    <section className="aliado-wrapper">
      <div className="aliado-section">
        <Container>
          <Row className="align-items-center aliado-content">
            <Col md={6} className="aliado-text text-start pe-md-0 pe-4 ps-md-0 ps-4">
              <h2>
                <strong>Somos el aliado confiable</strong> en la <br className="d-md-block d-none" />
                <strong>creación de beneficios para las empresas y sus colaboradores...</strong>
              </h2>

              <p>
                Nos <strong>especializamos</strong> en crear <strong>soluciones únicas de seguros</strong> que se
                adapten a sus necesidades, brindando coberturas a través de una plataforma de servicio auto
                administrada.
              </p>

              <p>
                <strong>Hoy</strong> en día, más de <strong>138 mil familias mexicanas</strong> tienen
                <br className="d-md-block d-none" />
                la <strong>tranquilidad</strong> de estar{" "}
                <strong>
                  protegidos bajo nuestro
                  <br className="d-md-block d-none" /> abanico de productos.
                </strong>
              </p>
            </Col>

            <Col md={6} className="position-relative d-md-block d-none">
              <img src={megaphone} alt="Megáfono" className="megaphone-img" />
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default Aliado;
